import React from "react";
import jwtDecode from "jwt-decode";
import { useNavigate } from "react-router-dom";

import { Button, Row, Col, Layout } from "antd";
import { QuestionCircleOutlined, UserOutlined } from "@ant-design/icons";
import { Content } from "antd/lib/layout/layout";

import AppContainer from "../../components/AppContainer/AppContainer";

import {
  COLORS,
  ManageUserAccount,
  ReportsSVG,
  SIZES,
} from "../../../constants";

import styles from "./styles/HomePageAdmin.module.css";
import BackgroundContainer from "../../components/BackgroundContainer/BackgroundContainer";

function HomePageAdmin() {
  const token = jwtDecode(localStorage.getItem("token"));
  const userType = token?.loginAs;
  const navigate = useNavigate();
  return (
    <Layout>
      <AppContainer>
        <Content className="homeContent">
          <BackgroundContainer>
            <Row align="middle" justify="center" className="containAll">
              <Col>
                <Button
                  className={styles.buttonBasic}
                  onClick={() => navigate(`/v2/my-account`)}
                  icon={
                    <UserOutlined
                      style={{
                        color: COLORS.blue,
                        fontSize: "50px",
                        margin: SIZES.base - 5,
                      }}
                    />
                  }
                >
                  <br />
                  My Account
                  <br />
                  Settings
                </Button>
              </Col>

              <Col>
                <Button
                  className={styles.buttonBasic}
                  onClick={() => navigate(`/v2/${userType}/accounts`)}
                >
                  <ManageUserAccount
                    style={{
                      color: COLORS.blue,
                      fontSize: "100px",
                      marginBottom: 5,
                      lineHeight: 0.7,
                    }}
                  />
                  <br />
                  <p>
                    Manage User <br /> Accounts
                  </p>
                </Button>
              </Col>

              <Col>
                <Button
                  className={styles.buttonBasic}
                  onClick={() => navigate(`/v2/${userType}/reports`)}
                >
                  <ReportsSVG
                    style={{
                      color: COLORS.blue,
                      fontSize: "100px",
                      marginBottom: 5,
                      lineHeight: 0,
                    }}
                  />
                  <br />
                  Management
                  <br />
                  Reports
                </Button>
              </Col>

              <Col>
                <Button
                  className={styles.buttonBasic}
                  onClick={() => {
                    navigate(`/v2/${userType}/faq`);
                  }}
                >
                  <Col>
                    <QuestionCircleOutlined
                      style={{
                        color: COLORS.blue,
                        lineHeight: 1,
                        fontSize: "50px",
                        margin: SIZES.base - 5,
                      }}
                    />
                  </Col>
                  Help / FAQ
                </Button>
              </Col>
            </Row>
          </BackgroundContainer>
        </Content>
      </AppContainer>
    </Layout>
  );
}

export default HomePageAdmin;
